import { Component, OnInit, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationLoaderService } from './core/services/translation-loader.service';
import { SplashScreenService } from './core/services/splash-screen.service';
import { locale as enLang } from './config/i18n/en';
import { locale as ruLang } from './config/i18n/ru';
import { locale as frLang } from './config/i18n/fr';
import {AppConfigService} from "./core/services/config.service";
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
   public loaderText: any;
   public colorString: string;
    constructor(
        private _splashScreenService: SplashScreenService,
        private _translateService: TranslateService,
        private configService: AppConfigService,
        private titleService: Title,
        private _translationLoaderService: TranslationLoaderService) {
        // Set translations
        this._translateService.addLangs(['en', 'ru', 'fr']);
        this._translationLoaderService.loadTranslations(enLang, ruLang, frLang);
        this._translateService.setDefaultLang('ru');
        this._translationLoaderService.setInitLang();
    }

    ngOnInit() {
      const clientName = this.configService.get('SIGLE');
      this.configService.get('SIGLE') === 'SIR' ? this.colorString = '#198754' : this.colorString = '#f36f21';

      const appTitle = clientName === 'SIR' ? 'HR Performance - Système d\'Entretien Individuel Annuel' :
        'Société Multinationale de Bitumes - Système d\'Entretien Individuel Annuel'
      const faviconUrl = clientName === 'SIR' ? 'assets/img/logo_sir.gif' : 'assets/img/SMB/logo-icon.png'

      this.titleService.setTitle(appTitle);
      this.updateFavicon(faviconUrl);
      this.setColorApp(this.configService.get('SIGLE'));
    }

    ngAfterViewInit(): void {
        this._splashScreenService.init();
    }

    setColorApp(sigle) {
      let primaryColor = '#0C8B3E';
      let secondaryColor = '#0C8B3E';
      if (sigle === 'SMB') {
        primaryColor = '#F18933';
        secondaryColor = '#353b48';
      } else if (sigle === 'SIR') {
        primaryColor = '#198754';
        secondaryColor = '#F18933';
      }
      document.documentElement.style.setProperty('--main', primaryColor);
      document.documentElement.style.setProperty('--secondary-item', secondaryColor);
    }

    updateFavicon(faviconUrl: string): void {
      const link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = faviconUrl;
      document.getElementsByTagName('head')[0].appendChild(link);
    }


}
